import styled from 'styled-components';
import { ITheme, IThemeProvider } from '../../../../../styles/theme';

interface WrapperProps {
  theme: ITheme;
  topicsCount: number;
}

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 17px;
  ${({ theme }: IThemeProvider) => `
    margin-top: ${theme.layout.spacing.mikro};
    color: ${theme.colors.neutral.primary[90]};
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
  display: grid;
  margin: 0.8rem 0 2rem 0;
  background: #f5f7fb;
  position: relative;
  gap: 3rem;

  ${({ theme, topicsCount }: WrapperProps) => `
    background: ${theme.colors.neutral.primary[5]};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    border-radius: ${theme.layout.spacing.mikro};
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 20px;
    grid-template-columns: repeat(${topicsCount}, 1fr);
  `}
`;
